(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["add-to-cart-button"] && !Shopify.designMode) return;
  try {
    const elaShineMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!elaShineMotion.matches && 'IntersectionObserver' in window) {
    const elaShineObserver = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting && !entry.target.disabled) {
          entry.target.classList.add('ela-shine-seen');
          elaShineObserver.unobserve(entry.target);
        }
      }
    }, { threshold: 0.75 });
    const elaRegisterShine = (root) => {
      for (const button of root.querySelectorAll('.ela-preorder-button:not(.ela-shine-seen)')) {
        elaShineObserver.observe(button);
        let lightFrame = 0;
        const moveLight = (event) => {
          if (elaShineMotion.matches || button.disabled) return;
          const bounds = button.getBoundingClientRect();
          const x = ((event.clientX - bounds.left) / bounds.width) * 100;
          const y = ((event.clientY - bounds.top) / bounds.height) * 100;
          cancelAnimationFrame(lightFrame);
          lightFrame = requestAnimationFrame(() => {
            button.style.setProperty('--ela-light-x', x + '%');
            button.style.setProperty('--ela-light-y', y + '%');
          });
        };
        button.addEventListener('pointermove', moveLight, { passive:true });
        button.addEventListener('pointerdown', moveLight, { passive:true });
        button.addEventListener('pointerleave', () => {
          cancelAnimationFrame(lightFrame);
          button.style.removeProperty('--ela-light-x');
          button.style.removeProperty('--ela-light-y');
        });
      }
    };
    elaRegisterShine(document);
    document.addEventListener('shopify:section:load', (event) => elaRegisterShine(event.target));
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ela-market-selectors"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ela-market-selectors')) {
    customElements.define('ela-market-selectors', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.querySelectorAll('[data-country-flag]').forEach(flag => {
          const code = flag.dataset.countryFlag.trim().toUpperCase();
          if (/^[A-Z]{2}$/.test(code)) flag.textContent = String.fromCodePoint(...[...code].map(letter => 127397 + letter.charCodeAt(0)));
        });
        const normalize = value => String(value ?? '').normalize('NFKD').toLocaleLowerCase().replace(/\p{M}/gu, '').replace(/[أإآٱ]/g, 'ا').replace(/ى/g, 'ي').replace(/ة/g, 'ه').replace(/ؤ/g, 'و').replace(/ئ/g, 'ي').replace(/[^\p{L}\p{N}]/gu, '');
        const aliases = {
          SA: ['السعودية','السعوديه','سعودية','سعوديه','المملكة العربية السعودية','المملكة','Saudi Arabia','Saudi','Kingdom of Saudi Arabia','KSA','SAU','SAR'],
          AE: ['الإمارات','الامارات','إمارات','امارات','الإمارات العربية المتحدة','دولة الإمارات','United Arab Emirates','Emirates','UAE','U.A.E.','ARE','AED','دبي','Dubai','أبوظبي','Abu Dhabi'],
          QA: ['قطر','دولة قطر','Qatar','Katar','QAT','QAR','الدوحة','Doha'],
          KW: ['الكويت','كويت','دولة الكويت','Kuwait','KWT','KWD'],
          OM: ['عمان','عُمان','سلطنة عمان','سلطنة عُمان','Oman','Sultanate of Oman','OMN','OMR'],
          BH: ['البحرين','بحرين','مملكة البحرين','Bahrain','Bahrein','Bahrayn','BHR','BHD','المنامة','Manama']
        };
        const gulf = ['SA','AE','QA','KW','OM','BH'];
        let arabicNames, englishNames;
        if (typeof Intl.DisplayNames === 'function') {
          arabicNames = new Intl.DisplayNames(['ar'], {type:'region'});
          englishNames = new Intl.DisplayNames(['en'], {type:'region'});
        }
        const countries = [...this.querySelectorAll('[data-country-name]')];
        const searchIndex = new Map(countries.map(item => {
          const code = item.dataset.countryCode;
          const terms = [item.dataset.countryName, code, item.dataset.countryCurrency, arabicNames?.of(code), englishNames?.of(code), ...(aliases[code] ?? [])];
          if (gulf.includes(code)) terms.push('الخليج','دول الخليج','مجلس التعاون الخليجي','Gulf','GCC');
          return [item, terms.filter(Boolean).map(normalize)];
        }));
        this.addEventListener('input', event => {
          if (!event.target.matches('[data-country-search]')) return;
          const term = normalize(event.target.value);
          let visible = 0;
          countries.forEach(item => {
            item.hidden = !searchIndex.get(item).some(name => name.includes(term));
            if (!item.hidden) visible++;
          });
          this.querySelector('[data-no-results]').hidden = visible > 0;
          this.querySelector('.ela-markets__country .ela-markets__list').scrollTop = 0;
        }, options);
        this.addEventListener('toggle', event => {
          if (event.target instanceof HTMLDetailsElement && event.target.open) {
            this.querySelectorAll('details').forEach(item => { if(item !== event.target) item.open = false; });
          }
        }, { ...options, capture: true });
        this.addEventListener('keydown', event => {
          if (event.key === 'Escape') {
            const opened = this.querySelector('details[open]');
            if (opened) { opened.open = false; opened.querySelector('summary').focus(); }
          }
        }, options);
        document.addEventListener('click', event => {
          if (!this.contains(event.target)) this.querySelectorAll('details').forEach(item => item.open = false);
        }, options);
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
